import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ad3db438"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-summary" }
const _hoisted_2 = { class: "mb-x6" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = { class: "inline-block min-w-35" }
const _hoisted_5 = { class: "mr-x2" }
const _hoisted_6 = { class: "whitespace-nowrap" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "my-x4" }, null, -1))
const _hoisted_8 = { class: "order-summary-line-wrap text-20 mb-x1" }
const _hoisted_9 = { class: "whitespace-nowrap" }
const _hoisted_10 = {
  key: 0,
  class: "order-summary-line-wrap text-13"
}
const _hoisted_11 = { class: "whitespace-nowrap" }
const _hoisted_12 = {
  key: 0,
  class: "order-summary-line-wrap mb-4"
}
const _hoisted_13 = { class: "whitespace-nowrap" }
const _hoisted_14 = {
  key: 1,
  class: "order-summary-line-wrap mb-4"
}
const _hoisted_15 = { class: "whitespace-nowrap" }
const _hoisted_16 = {
  key: 2,
  class: "order-summary-line-wrap mb-4"
}
const _hoisted_17 = { class: "whitespace-nowrap" }
const _hoisted_18 = {
  key: 3,
  class: "order-summary-line-wrap mb-4"
}
const _hoisted_19 = { class: "whitespace-nowrap" }
const _hoisted_20 = {
  key: 4,
  class: "order-summary-line-wrap mb-4"
}
const _hoisted_21 = { class: "whitespace-nowrap" }
const _hoisted_22 = {
  key: 5,
  class: "order-summary-line-wrap text-20 mt-x1"
}
const _hoisted_23 = { class: "whitespace-nowrap" }

import { useCheckout } from '@/b2b/checkout/useCheckout';
import AnimateValue from '@/core/ui-components/AnimateValue.vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import NetPrice from '@/b2b/shared/auth/ui/NetPrice.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutOrderSummary',
  setup(__props) {

const labels = useBlockLabels();
const { items, summary } = useCheckout();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(labels).orderSummaryHeader), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items), (item) => {
      return (_openBlock(), _createElementBlock("dl", {
        key: item.id,
        class: "flex flex-row flex-nowrap justify-between text-13 mb-5 last:mb-0"
      }, [
        _createElementVNode("dt", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(item.quantity), 1),
          _createElementVNode("span", _hoisted_5, _toDisplayString(item.name), 1)
        ]),
        _createElementVNode("dd", _hoisted_6, _toDisplayString(item.price?.rrPriceTotal?.amount), 1)
      ]))
    }), 128)),
    _hoisted_7,
    _createElementVNode("dl", _hoisted_8, [
      _createElementVNode("dt", null, _toDisplayString(_unref(labels).orderSummaryTotal), 1),
      _createElementVNode("dd", _hoisted_9, [
        (_unref(summary).rrpPriceTotal?.amount)
          ? (_openBlock(), _createBlock(AnimateValue, {
              key: 0,
              value: _unref(summary).rrpPriceTotal.amount
            }, null, 8, ["value"]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_unref(summary).ecoTaxTotal)
      ? (_openBlock(), _createElementBlock("dl", _hoisted_10, [
          _createElementVNode("dt", null, _toDisplayString(_unref(labels).orderSummaryEcoTax), 1),
          _createElementVNode("dd", _hoisted_11, _toDisplayString(_unref(summary).ecoTaxTotal.amount), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(NetPrice, { class: "text-partner font-bold mt-x2" }, {
      default: _withCtx(() => [
        (_unref(summary).listPriceTotal)
          ? (_openBlock(), _createElementBlock("dl", _hoisted_12, [
              _createElementVNode("dt", null, _toDisplayString(_unref(labels).orderSummaryNetPriceSubTotal), 1),
              _createElementVNode("dd", _hoisted_13, _toDisplayString(_unref(summary).listPriceTotal?.amount), 1)
            ]))
          : _createCommentVNode("", true),
        (_unref(summary).discountTotal?.amount)
          ? (_openBlock(), _createElementBlock("dl", _hoisted_14, [
              _createElementVNode("dt", null, _toDisplayString(_unref(labels).orderSummaryNetPriceDiscount), 1),
              _createElementVNode("dd", _hoisted_15, " -" + _toDisplayString(_unref(summary).discountTotal.amount), 1)
            ]))
          : _createCommentVNode("", true),
        (_unref(summary).showFreightPriceTotal)
          ? (_openBlock(), _createElementBlock("dl", _hoisted_16, [
              _createElementVNode("dt", null, _toDisplayString(_unref(labels).orderSummaryNetPriceStandardShipping), 1),
              _createElementVNode("dd", _hoisted_17, _toDisplayString(_unref(summary).freightPriceTotal ? _unref(summary).freightPriceTotal.amount : _unref(labels).orderSummaryNetPriceStandardShippingDescription), 1)
            ]))
          : _createCommentVNode("", true),
        (_unref(summary).expressFreightPriceTotal?.rawAmount)
          ? (_openBlock(), _createElementBlock("dl", _hoisted_18, [
              _createElementVNode("dt", null, _toDisplayString(_unref(labels).orderSummaryNetPriceExpressShipping), 1),
              _createElementVNode("dd", _hoisted_19, _toDisplayString(_unref(summary).expressFreightPriceTotal?.amount), 1)
            ]))
          : _createCommentVNode("", true),
        (_unref(summary)?.rrpSalesTax)
          ? (_openBlock(), _createElementBlock("dl", _hoisted_20, [
              _createElementVNode("dt", null, _toDisplayString(_unref(labels).orderSummarySalesTax), 1),
              _createElementVNode("dd", _hoisted_21, _toDisplayString(_unref(summary).rrpSalesTax.amount), 1)
            ]))
          : _createCommentVNode("", true),
        (_unref(summary).salesPriceTotal)
          ? (_openBlock(), _createElementBlock("dl", _hoisted_22, [
              _createElementVNode("dt", null, _toDisplayString(_unref(labels).orderSummaryNetPriceTotal), 1),
              _createElementVNode("dd", _hoisted_23, [
                _createVNode(AnimateValue, {
                  value: _unref(summary).salesPriceTotal.amount
                }, null, 8, ["value"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})